import { SAGA_ACTIONS } from 'src/_config'
import { GameCmsReq, GetCmsContent } from 'src/_common/interfaces/ApiReqRes'
import { useApiCall } from '../common/appApiCallHook'



export function useCmsApi() {

    const callApi = useApiCall()

    const getCmsContent = (data: GetCmsContent, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.CMS.GET_CMS, data, onSuccess, onError);
    }

    const gameCms = (data: GameCmsReq, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.CMS.GET_GAME_CMS, data, onSuccess, onError);
    }

    return {
        callGetCmsContent: getCmsContent,
        callGameCms: gameCms,
    }
}